import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
import { ACTIONS_COL } from '@/types/interfaces';
import { validate } from '@/utils';
export default /*#__PURE__*/_defineComponent({
  __name: 'card-headers',
  props: {
    headers: null,
    canSelect: {
      type: Boolean,
      default: true
    },
    showActions: {
      type: Boolean,
      default: true
    },
    canExpand: {
      type: Boolean,
      default: true
    }
  },
  setup(__props) {
    const props = __props;
    const {
      isEllipses
    } = validate;
    const relevantColumns = computed(() => {
      return props.headers.filter(header => header.row);
    });
    // even (0-indexed) headers are part of column 1
    const columnOneNames = computed(() => {
      const array = relevantColumns.value.filter(e => {
        return !columnTwoNames.value.includes(e.label);
      });
      return array.map(header => header.label);
    });
    // odd (0-indexed) headers are part of column 2
    const columnTwoNames = computed(() => {
      let result = [];
      if (rows.value[0].length > 1) {
        result = [rows.value[0][1].label];
      }
      if (props.showActions) {
        result = [...result, ACTIONS_COL.label];
      }
      return result;
    });
    const rows = computed(() => {
      const headers = [];
      headers.push(relevantColumns.value.filter(e => {
        return e.row === 1;
      }));
      headers.push(relevantColumns.value.filter(e => {
        return e.row === 2;
      }));
      headers.push(relevantColumns.value.filter(e => {
        return e.row === 3;
      }));
      return headers;
    });
    return {
      __sfc: true,
      isEllipses,
      props,
      relevantColumns,
      columnOneNames,
      columnTwoNames,
      rows
    };
  }
});